export default __webpack_public_path__ + "static/FritzphoneC4_05-770228451fa2a6fae6aa5698d8648cff.webp";